import { render, staticRenderFns } from "./ad.vue?vue&type=template&id=71d2b28b&scoped=true&"
import script from "./ad.vue?vue&type=script&lang=js&"
export * from "./ad.vue?vue&type=script&lang=js&"
import style0 from "./ad.vue?vue&type=style&index=0&id=71d2b28b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d2b28b",
  null
  
)

export default component.exports